export const ghostFlyoutIdSuffix = "ghostFlyout";
